"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: ()=>_default
});
const settings = {
    appTitle: 'QA App',
    merchantOrg: 'NOTCONFIGURED',
    images: {
        fullLogo: '',
        navLogo: ''
    },
    navType: 'stack',
    isContrast: true,
    hasCustomBackground: false,
    background: {
        light: '',
        dark: ''
    },
    bottomNav: [
        {
            toScreen: 'Milestones',
            customLabel: '  ',
            icon: 'fa-bars-progress',
            path: 'w/:wallet_id/milestones'
        },
        {
            toScreen: 'Subscriptions',
            customLabel: '  ',
            icon: 'fa-bars-progress',
            path: 'w/:wallet_id/subscriptions'
        },
        {
            toScreen: 'Profile',
            customLabel: '  ',
            icon: 'fa-user',
            path: 'w/:wallet_id/profile'
        },
        {
            toScreen: 'Messages',
            customLabel: '  ',
            icon: 'fa-message',
            path: 'w/:wallet_id/messages'
        },
        {
            toScreen: 'Refer',
            customLabel: '  ',
            path: 'w/:wallet_id/refer',
            icon: 'fa-user-group'
        }
    ],
    firebase_project_id: 1,
    profile: {
        profileIcon: false,
        profileQRCode: true
    },
    redeemRewardInStore: false,
    redeemOfferInStore: false,
    expirationDateInDays: 90,
    isMenu: true,
    bottomTabsLength: 4,
    showVipBar: true,
    rewards: {
        showInCenter: true
    },
    isDisabledSideNav: false,
    redirections: {},
    account: {
        notification: {
            hideEmailToggle: false
        },
        disable_signature: {
            email: true,
            sms: false,
            loyalty: true
        }
    },
    loyalty_wallet_opt_in: true,
    pageHeaders: {
        'Milestones': {
            title: 'milestones.title',
            showBackButton: false,
            show: true
        },
        'Offers': {
            title: 'offers.available_offers',
            showBackButton: false,
            show: true
        },
        'Refer': {
            title: 'refer.title',
            showBackButton: true,
            show: true
        },
        'profile/menu': {
            title: 'profile.my_account',
            showBackButton: true,
            show: true
        },
        'profile/menu/history': {
            title: 'profileMenu.recent_history',
            showBackButton: true,
            show: true
        },
        'profile/menu/settings': {
            title: 'profileMenu.message_notifications',
            showBackButton: true,
            show: true
        },
        'profile/menu/account': {
            title: 'profileMenu.my_information',
            showBackButton: true,
            show: true
        },
        'Subscriptions': {
            title: 'subscriptions.title',
            showBackButton: false,
            show: true
        }
    },
    requireEmailVerficationGiftCard: true,
    enableGeofencingBypass: true,
    showSubscriptionPrompt: true,
    hide_refer_title: false,
    hide_home_page: false,
    splashAnimationType: 'pulse',
    show_leave_a_review: false
};
const _default = settings;
